// For uploading signatures from EditJobOrder to Generate Receipts.js
import AWS from 'aws-sdk';

AWS.config.update({
    accessKeyId: 'AKIAVXGA6A4KYPO7UBZM', // Your Access Key ID
    secretAccessKey: 'COc4EQACzlZPDiySiWjlxxqW2AdUttIHzOBMq/rO', // Your Secret Access Key
    region: 'ap-southeast-1', // Your S3 bucket's region
  });

const TEMP_BUCKET_NAME = 'boaz-temp-bucket';
const s3TempBucketUploader = new AWS.S3();

export { s3TempBucketUploader, TEMP_BUCKET_NAME };